import React, { useState } from 'react'
import { Authentication } from 'domain/usecases/authentication/authentication'
import LoginLayout from 'presentation/shared/layouts/Login'
import { VerifyLoginClient } from 'domain/usecases/authentication/verify-client'
import { Profile } from 'common/enum/profile'
import MaintenanceNoticeResponsiveModal from 'presentation/shared/components/MaintenanceNoticeResponsiveModal'
import { isMaintenanceNoticeEnabled } from 'common/utils/feature-flags'

type LoginProps = {
  useCase: Authentication
  verifyClient: VerifyLoginClient
  client: Profile
}

export default function Login({ useCase, verifyClient, client }: LoginProps) {
  const [isMaintenanceNoticeOpen, setIsMaintenanceNoticeOpen] = useState(
    isMaintenanceNoticeEnabled()
  )

  return (
    <>
      <LoginLayout
        client={client}
        verifyClient={verifyClient}
        useCase={useCase}
      />
      <MaintenanceNoticeResponsiveModal
        isOpen={isMaintenanceNoticeOpen}
        onClose={() => setIsMaintenanceNoticeOpen(false)}
      />
    </>
  )
}

export type LoginFormValues = {
  cpf: string
  password: string
  remember: boolean
}
